var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('v-row',{attrs:{"dense":"","no-gutters":""}},[_c('login-left'),_c('reset-password-right'),_c('v-col',{attrs:{"cols":"12","lg":"1","md":"1","sm":"1","xl":"1","xs":"12"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }